<section class="page-title-area">
    <div class="container">
        <div class="page-title-content wow animate__animated animate__fadeInLeft" data-wow-delay="00ms" data-wow-duration="1000ms">
            <img src="assets/img/icons/mobile-app.svg" alt="image">
            <h1 class="pt-3">Register Play Mobile App</h1>
            <p>Unite, compete, and stay connected—right from your phone. The Register Play app brings team management and communication into your pocket, making it easier than ever to stay on top of your game, wherever you are.</p>
            <div class="app-download-links mt-4">
                <a href="https://apps.apple.com/us/app/register-play/id6698850945" target="_blank" style="margin-right: 24px">
                    <img src="assets/img/icons/appstore.svg" alt="Download on the App Store" style="height: 150px;">
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.registerplay.regply" target="_blank">
                    <img src="assets/img/icons/googleplay.svg" alt="Get it on Google Play" style="height: 150px;">
                </a>
            </div>
        </div>
    </div>
</section>

<section class="services-area bg-f9f9f9 pb-70">
    <div class="container position-relative z-index-3 my-5">
        <div class="row align-items-center justify-content-center wow animate__animated animate__fadeInDown" data-wow-delay="00ms">
            <div class="col-lg-12">
                <h4 class="text-color-primary font-weight-medium text-4 mt-5 text-uppercase">Team Pages</h4>
                <p class="custom-font-secondary custom-font-size-1 line-height-7 pb-2 text-justified">Showcase your team directly from the app—upload your logo, team photo, and roster. Keep fans and players updated with team details and accomplishments in real-time.</p>
            </div>
        </div>

        <div class="row align-items-center justify-content-center wow animate__animated animate__fadeInDown" data-wow-delay="00ms">
            <div class="col-lg-12">
                <h4 class="text-color-primary font-weight-medium text-4 mt-5 text-uppercase">Player Pages</h4>
                <p class="custom-font-secondary custom-font-size-1 line-height-7 pb-2 text-justified">View your players or opponent player directly from the app. Roster History, Measurables and more.</p>
            </div>
        </div>

        <div class="row align-items-center justify-content-center wow animate__animated animate__fadeInDown" data-wow-delay="00ms">
            <div class="col-lg-12">
                <h4 class="text-color-primary font-weight-medium text-4 mt-5 text-uppercase">Roster Management</h4>
                <p class="custom-font-secondary custom-font-size-1 line-height-7 pb-2 text-justified">Easily add or manage players, update eligibility, and print rosters—all from your phone. Players and parents can join and update their profiles seamlessly in-app.</p>
            </div>
        </div>

        <div class="row align-items-center justify-content-center wow animate__animated animate__fadeInDown" data-wow-delay="00ms">
            <div class="col-lg-12">
                <h4 class="text-color-primary font-weight-medium text-4 mt-5 text-uppercase">Schedules & Results</h4>
                <p class="custom-font-secondary custom-font-size-1 line-height-7 pb-2 text-justified">Get instant access to your team’s schedule, live score updates, and final results. Enable push notifications so your team never misses a game change or announcement.</p>
            </div>
        </div>

        <div class="row align-items-center justify-content-center wow animate__animated animate__fadeInDown" data-wow-delay="00ms">
            <div class="col-lg-12">
                <h4 class="text-color-primary font-weight-medium text-4 mt-5 text-uppercase">Rankings & Standings</h4>
                <p class="custom-font-secondary custom-font-size-1 line-height-7 pb-2 text-justified">Track team progress with real-time leaderboards. Rankings are automatically calculated based on results—no manual entry required.</p>
            </div>
        </div>

        <div class="row align-items-center justify-content-center wow animate__animated animate__fadeInDown" data-wow-delay="00ms">
            <div class="col-lg-12">
                <h4 class="text-color-primary font-weight-medium text-4 mt-5 text-uppercase">In-App Messaging (Coming Soon)</h4>
                <p class="custom-font-secondary custom-font-size-1 line-height-7 pb-2 text-justified">Coming soon: A built-in chat system to help coaches, players, and parents communicate instantly. From last-minute changes to team strategy, everything stays organized.</p>
            </div>
        </div>

        <div class="row align-items-center justify-content-center wow animate__animated animate__fadeInDown" data-wow-delay="00ms">
            <div class="col-lg-12 text-center mt-5">
                <p class="custom-font-secondary custom-font-size-1 line-height-7 mb-3">Download the Register Play Mobile App today and take your team with you—anytime, anywhere.</p>
                <div class="app-download-links">
                    <a href="https://apps.apple.com/us/app/register-play/id6698850945" target="_blank" style="margin-right: 24px">
                        <img src="assets/img/icons/appstore.svg" alt="Download on the App Store" style="height: 150px;">
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.registerplay.regply" target="_blank">
                        <img src="assets/img/icons/googleplay.svg" alt="Get it on Google Play" style="height: 150px;">
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
